import request from 'services/axios'

/**
 * Pending cashbox invitations (to me) + membership requests (to boxes I own).
 *
 * The path used to read `/ment/cashbox/invited-and-request-list/` — the leading
 * `cashbox_manage` had been sliced off, so this 404'd on every call.
 * `inviteCount` on the messages page was therefore permanently 0 and the
 * «درخواست عضویت» band never appeared: a user invited to a cashbox had no way
 * to learn about it from the PWA.
 */
export const getCashBoxMessages = async () => {
    const { data }: { data: { results: Array<ICashboxDetail> } } =
        await request.get(
            `/cashbox_management/cashbox/invited-and-request-list/`
        )
    return data
}

/** The number on the footer's «پیام‌ها» tab; the server stops counting at 100. */
export const getUnseenMessageCount = async () => {
    const { data }: { data: { count: number } } = await request.get(
        '/peripheral/message/unseen-count/'
    )
    return data.count
}

export interface InboxQuery {
    before?: number
    period?: TInboxPeriod
    category?: TInboxCategory
}

/**
 * One page of the inbox, newest first, optionally narrowed by time and by what
 * the message is about. Android's `request-messages-in-page-v2` pages by *day*,
 * which a filter breaks (a day can hold one matching row or none), so the PWA
 * has its own keyset endpoint and groups by day itself.
 */
export const getInboxPage = async ({ before, period, category }: InboxQuery) => {
    const params: Record<string, string> = {}
    if (before) params.before = String(before)
    if (period) params.period = period
    if (category) params.category = category
    const { data }: { data: IInboxPage } = await request.get(
        '/peripheral/message/inbox/',
        { params }
    )
    return data
}

/** «گفت‌وگوی وام»: the loan requests whose thread I am part of. */
export const getLoanThreads = async () => {
    const { data }: { data: { results: ILoanThread[] } } = await request.get(
        '/peripheral/message/loan-threads/'
    )
    return data.results
}

/**
 * Marks `lastMessageId` and every older message of the member as seen
 * (`Message.make_older_messages_seen`), so the newest id on screen is enough.
 */
export const makeMessagesSeen = async (lastMessageId: number) => {
    await request.post(
        `/peripheral/message/make-message-seen/${lastMessageId}/`
    )
}

export const deleteMessage = async (messageId: number) => {
    await request.post(`/peripheral/message/delete-message/${messageId}/`)
}
